@if (apiError) {
    <article class="message is-danger">
        <div class="message-body p-3">
            <b>{{ apiError.message }}</b>
            @for (error of apiError.input; track $index) {
                <span class="is-block">
                      @if (error.key) {
                          <span>{{ error.key }}: </span>
                      }
                    {{ error.error }}
                </span>
            }
        </div>
    </article>
}
